module.exports = __webpack_public_path__ + "img/hostal-de-la-luz-regalo.08e09aa0.png";